<template>
	<div>
		<div class="banner">
			<swiper ref="banner" :options="bannerOptions" class="bannerOptions">
				<swiper-slide>
					<div class="bannerDiv" :style="{background: 'url('+banner1+') center'}">
						<div class="bannerBtn" @click="$open.open">
							<span>立即咨询 “数字员工”</span>
							<img src="@/assets/index/btn.png" alt="">
						</div>
					</div>
				</swiper-slide>
				<swiper-slide>
					<div class="bannerDiv" :style="{background: 'url('+banner2+') center'}">
						<div class="bannerBtn" style="left: 50%;margin-left: -600px;top: 60%;position: absolute;" @click="$open.open">
							<span>立即咨询 “数字员工”</span>
							<img src="@/assets/index/btn.png" alt="">
						</div>
					</div>
				</swiper-slide>
				<swiper-slide>
					<div class="bannerDiv" :style="{background: 'url('+banner3+') center'}">
						<div class="bannerBtn" style="left: 50%;margin-left: -600px;top: 60%;position: absolute;" @click="$open.open">
							<span>立即咨询 “数字员工”</span>
							<img src="@/assets/index/btn.png" alt="">
						</div>
					</div>
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
		</div>
		<div class="video">
			<div class="centBlock">
				<p class="blockName">从此改变工作方式</p>
				<p class="blockBrief">语音交办任务 · 自主时间安排 · 工作简单高效</p>
				<div class="videoDiv">
					<img src="@/assets/index/play.png" alt="">
				</div>
			</div>
		</div>
		<div class="technology">
			<div class="centBlock">
				<p class="blockName">核心技术</p>
				<p class="blockBrief">以感知、认知、岗位机器人操作系统为核心为机器人赋能</p>
				<div class="technologyList">
					<div class="technologyLi" :class="{technologyChosen:technologyChosen == 1}" @mouseover="technologyDown('1')">
						<router-link :to="{path:'/technology'}" class="more">
							<img src="@/assets/index/more.png" alt="">
							<span>了解更多</span>
						</router-link>
						<div class="technologyName">
							<img v-if="technologyChosen == 1" src="@/assets/index/tech1.png" alt="">
							<img v-else src="@/assets/index/tech11.png" alt="">
							<span>语音</span>
						</div>
						<div class="technologyType">自然语言处理</div>
						<div class="technologyType">语义识别</div>
						<div class="technologyType">阅读理解</div>
					</div>
					<div class="technologyLi" :class="{technologyChosen:technologyChosen == 2}" @mouseover="technologyDown('2')">
						<router-link :to="{path:'/technology'}" class="more">
							<img src="@/assets/index/more.png" alt="">
							<span>了解更多</span>
						</router-link>
						<div class="technologyName">
							<img v-if="technologyChosen == 2" src="@/assets/index/tech2.png" alt="">
							<img v-else src="@/assets/index/tech22.png" alt="">
							<span>感知</span>
						</div>
						<div class="technologyType">人脸识别</div>
						<div class="technologyType">OCR识别</div>
						<div class="technologyType">图像分析</div>
					</div>
					<div class="technologyLi" :class="{technologyChosen:technologyChosen == 3}" @mouseover="technologyDown('3')">
						<router-link :to="{path:'/technology'}" class="more">
							<img src="@/assets/index/more.png" alt="">
							<span>了解更多</span>
						</router-link>
						<div class="technologyName">
							<img v-if="technologyChosen == 3" src="@/assets/index/tech3.png" alt="">
							<img v-else src="@/assets/index/tech33.png" alt="">
							<span>认知</span>
						</div>
						<div class="technologyType">对象标签</div>
						<div class="technologyType">机器学习</div>
						<div class="technologyType">知识图谱</div>
					</div>
					<div class="technologyLi" :class="{technologyChosen:technologyChosen == 4}" @mouseover="technologyDown('4')">
						<router-link :to="{path:'/technology'}" class="more">
							<img src="@/assets/index/more.png" alt="">
							<span>了解更多</span>
						</router-link>
						<div class="technologyName">
							<img v-if="technologyChosen == 4" src="@/assets/index/tech4.png" alt="">
							<img v-else src="@/assets/index/tech44.png" alt="">
							<span>执行</span>
						</div>
						<div class="technologyType">流程配置</div>
						<div class="technologyType">时间管理</div>
						<div class="technologyType">能力库</div>
					</div>
				</div>
			</div>
		</div>
		<div class="industry">
			<p class="blockName">行业应用</p>
			<p class="blockBrief">岗位机器人操作系统，赋能多行业应用解决方案</p>
			<div class="industryList">
				<div class="industryLi" :class="{industryChosen:industryIndex == i}" v-for="(item,i) in industry" @mouseover="industryDown(i)">
					<div class="industryCen">
						<span>{{item.name}}</span>
					</div>
					<img :src="item.img" alt="">
					<div class="industryInfo" v-if="industryIndex == i">
						<p class="industryName">{{item.name}}</p>
						<p class="industryTxt">{{item.txt}}</p>
						<router-link :to="{path:'/programme'}" class="more">
							<img src="@/assets/index/more.png" alt="">
							<span>了解更多</span>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="contact">
			<div class="centBlock">
				<p class="blockName">联系我们</p>
				<p class="blockBrief">立即开启你的人机协同智能工作之旅</p>
				<div class="phone">
					<img src="@/assets/index/phone.png" alt="">
					<span class="phoneName">全国热线</span>
					<span>400-001-0224</span>
				</div>
				<div class="bannerBtn" @click="$open.open">
					<span>立即咨询 “数字员工”</span>
					<img src="@/assets/index/btn.png" alt="">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
	    data(){
	        return{
	            banner1: require('@/assets/index/banner1.png'),
                banner2: require('@/assets/index/banner2.png'),
                banner3: require('@/assets/index/banner3.png'),
                technologyChosen: -1,
                industry: [
	                {
	                    name: '企业',
		                txt: '以智能机器人为载体，结合企业服务系统，实现企业日常办公辅助、安保巡防、迎宾接待、业务咨询、任务执行等服务，降低人工运营管理压力及成本，有效改善企业的运营效率，实现企业降本增效。',
		                img: require("@/assets/index/industry1.png")
	                },
                    {
                        name: '政务',
                        txt: '利用AI+大数据+智能服务机器人的模式构建智慧政务服务平台，提供迎宾接待、业务咨询、辅助办理等服务，助力政府提升行政效率，推动公共服务创新，为智慧转型提供支持。',
                        img: require("@/assets/index/industry2.png")
                    },
                    {
                        name: '教育',
                        txt: '通过人机交互及专业系统的内容架构，提供各地区、各优秀教师的先进教学理念、教学方法、教学资源，共享给更多学生和教师。通过开放、共享、交互、协作等形式，以教育信息化促进教育现代化，用信息技术改变传统教育模式。',
                        img: require("@/assets/index/industry3.png")
                    },
                    {
                        name: '展馆',
                        txt: '通过整合软硬件平台，结合场景专属数字化展示方案，可提供业务咨询、呼叫应答、分流引导，主动迎宾，主动宣讲等智能服务。广泛应用于各类展览、博物馆、文化馆等场景，实现展厅智能服务升级，生动形象地诠释文化内涵。',
                        img: require("@/assets/index/industry4.png")
                    },
                    {
                        name: '医疗',
                        txt: '通过机器人进行导诊导医，根据关键词批量匹配，可为患者提供口语化的疾病症状分诊，为患者推荐就诊科室和相关科室医生，同时可以语音问询业务办理方法、生活信息、政策信息等常见问题，医患数据采集，缓解医院看病压力。',
                        img: require("@/assets/index/industry5.png")
                    },
                    {
                        name: '农业',
                        txt: '通过机器人进行导诊导医，根据关键词批量匹配，可为患者提供口语化的疾病症状分诊，为患者推荐就诊科室和相关科室医生，同时可以语音问询业务办理方法、生活信息、政策信息等常见问题，医患数据采集，缓解医院看病压力。',
                        img: require("@/assets/index/industry6.png")
                    },
                    {
                        name: '园区',
                        txt: '基于人脸识别和环境监控，针对园区的人员安全，园区安全，人性化服务，全面提升园区的管理效率与安全等级。',
                        img: require("@/assets/index/industry7.png")
                    },
                    {
                        name: '工地',
                        txt: '基于物联网设备和监控设备，针对工地的人员安全、车辆进出，工地环境和安全提供全面的管理。为项目进展情况提供有力的数据支撑。',
                        img: require("@/assets/index/industry8.png")
                    },
                ],
                industryIndex: 0,
	            bannerOptions:{
		            autoplay: {
		                delay: 5000,
		                disableOnInteraction: false,
		            },
                    pagination: {
	                    el: ".swiper-pagination",
	                    clickable: true,
                    },
	            },
	        }
	    },
		methods:{
            technologyDown(num){
                this.technologyChosen = num;
            },
            industryDown(num){
                this.industryIndex = num;
            }
		},
		mounted() {
            document.documentElement.scrollTop = 0;
        }
    }
</script>
<style scoped>
	.banner{
		width: 100%;
		height: 800px;
	}
	.bannerDiv{
		width: 100%;
		height: 100%;
		/*background: url("~@/assets/index/banner1.png") center;*/
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.bannerBtn{
		width: 400px;
		height: 60px;
		background: #FFFFFF;
		border-radius: 40px;
		position: relative;
		text-align: center;
		line-height: 60px;
		font-size: 20px;
		color: #242E3A;
		margin: auto;
		cursor: pointer;
	}
	.bannerBtn img{
		position: absolute;
		right: 7px;
		top: 6px;
	}
	.video{
		width: 100%;
		height: 770px;
		padding-top: 60px;
	}
	.videoDiv{
		width: 900px;
		height: 500px;
		margin: auto;
		margin-top: 40px;
		background: url("~@/assets/index/videoBgd.png") center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.technology{
		width: 100%;
		height: 720px;
		padding-top: 60px;
		background: url("~@/assets/index/technologyBgd.png") center;
	}
	.blockName{
		font-size: 36px;
		line-height: 50px;
		color: #242E3A;
		text-align: center;
	}
	.blockBrief{
		font-size: 20px;
		line-height: 28px;
		color: #A7ABB0;
		text-align: center;
		margin-top: 22px;
	}
	.technologyList{
		width: 100%;
		height: 380px;
		display: flex;
		align-items: center;
		margin-top: 90px;
	}
	.technologyLi{
		width: 270px;
		height: 100%;
		margin-right: 30px;
		background: #FFFFFF;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 47px;
		position: relative;
	}
	.technologyName{
		display: flex;
		align-items: center;
		font-size: 24px;
		line-height: 34px;
		color: #242E3A;
		margin-bottom: 44px;
	}
	.technologyName img{
		margin-right: 10px;
	}
	.technologyType{
		width: 100%;
		height: 34px;
		border: 1px solid #A7ABB0;
		font-size: 16px;
		color: #A7ABB0;
		text-align: center;
		line-height: 34px;
		margin-bottom: 10px;
	}
	.technologyType:last-child{
		margin-bottom: 0;
	}
	.more{
		display: flex;
		align-items: center;
		font-size: 16px;
		line-height: 22px;
		color: rgba(255, 255, 255, 0.4);
		position: absolute;
		left: 50%;
		bottom: 60px;
		margin-left: -41px;
		text-decoration: none;
	}
	.more img{
		margin-right: 9px;
	}
	.technologyChosen{
		height: 440px;
		background: #1373EC;
	}
	.technologyChosen .technologyName{
		color: #fff;
	}
	.technologyChosen .technologyType{
		border: 1px solid rgba(255, 255, 255, 0.6);
		color: rgba(255, 255, 255, 0.6);
	}
	.industry{
		width: 100%;
		height: 700px;
		padding-top: 60px;
		background: url("~@/assets/index/industryBgd.png") center;
	}
	.industry .blockName{
		color: #fff;
	}
	.industry .blockBrief{
		color: rgba(255, 255, 255, 0.4);
	}
	.industryList{
		width: 100%;
		height: 400px;
		margin-top: 60px;
		display: flex;
		overflow-x: auto;
	}
	.industryList::-webkit-scrollbar{
		display: none;
	}
	.industryLi{
		width: 217px;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.industryChosen{
		min-width: 404px;
	}
	.industryLi img{
		height: 100%;
	}
	.industryCen{
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
		background: rgba(12, 48, 90, 0.7);
		display: flex;
		align-items: flex-end;
		justify-content: center;
		font-size: 24px;
		line-height: 34px;
		color: #FFFFFF;
		padding-bottom: 78px;
		cursor: pointer;
	}
	.industryInfo{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		background: #1373EC;
		padding: 82px 46px 0 48px;
		font-size: 16px;
		line-height: 22px;
		color: #FFFFFF;
	}
	.industryName{
		font-size: 20px;
		line-height: 28px;
		margin-bottom: 40px;
	}
	.industryTxt{
		margin-bottom: 30px;
	}
	.industryInfo .more{
		position: static;
		margin-left: 0;
	}
	.contact{
		width: 100%;
		height: 450px;
		padding-top: 60px;
		background: url("~@/assets/index/contactBgd.png") center;
	}
	.phone{
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 36px;
		line-height: 50px;
		margin-top: 50px;
		margin-bottom: 50px;
	}
	.phone img{
		margin-right: 20px;
	}
	.phoneName{
		color: #1373EC;
		margin-right: 27px;
	}
	.swiper-container {
		width: 100%;
		height: 100%;
	}
	.swiper-container-horizontal > .swiper-pagination-bullets{
		bottom: 36px;
	}
	.swiper-slide {
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
		transition: 300ms;
	}
	.bannerOptions >>> .swiper-pagination-bullet{
		width: 30px;
		height: 4px;
		border-radius: 0;
		background: rgba(255, 255, 255, 0.4);
	}
	.bannerOptions >>> .swiper-pagination-bullet-active{
		background: #FFFFFF;
	}
	.bannerOptions >>> .swiper-pagination-bullets{
		bottom: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue